import { SupplierEnquiryFormSuccess } from '@/components/v3/unique/supplier/supplier-enquiry-form-success/supplier-enquiry-form-success'
import { useModal } from '@/hooks/use-modal'
import s from './supplier-enquiry-form-success-modal.module.scss'

export const SupplierEnquiryFormSuccessModal = () => {
  const modal = useModal()
  const relatedSuppliers = modal.options.modalProps.relatedSuppliers || []
  const supplierTitle = modal.options.modalProps.supplierTitle || ''
  const supplierSlug = modal.options.modalProps.supplierSlug || ''

  const handleCancelBtn = () => {
    modal.close()
  }

  return (
    <div className={s.container}>
      <SupplierEnquiryFormSuccess
        relatedSuppliers={relatedSuppliers}
        supplierTitle={supplierTitle}
        supplierSlug={supplierSlug}
        handleCancelBtn={handleCancelBtn}
      />
    </div>
  )
}
